module.exports = __webpack_public_path__ + "bg_renove.png?c844a7bac40cebe86604d5ad61c87efe";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_renove.png
// module id = 57
// module chunks = 0